'use client';
import { Skeleton } from './ui/skeleton';

export function PageSkeleton() {
    return (
        <div className="mx-auto max-w-5xl p-6">
            <div className="mb-4 flex items-center space-x-2">
                <Skeleton className="h-4 w-16" />
                <span className="opacity-50">/</span>
                <Skeleton className="h-4 w-24" />
                <span className="opacity-50">/</span>
                <Skeleton className="h-4 w-32" />
            </div>

            <Skeleton className="h-8 w-64 mb-6" />

            <div className="mt-6">
                <div className="rounded-x40 border border-stroke-x30 p-4">
                    <Skeleton className="h-5 w-16 mb-3" />
                    <div className="rounded-x30">
                        <Skeleton className="h-64 w-full" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export function SidebarSkeleton() {
    return (
        <div className="p-4 space-y-4">
            <div className="flex justify-end">
                <Skeleton className="h-6 w-16" />
            </div>
            <div className="h-px bg-border my-2" />

            {Array.from({ length: 3 }).map((_, categoryIndex) => (
                <div key={categoryIndex} className="space-y-2">
                    <Skeleton className="h-4 w-20" />
                    <div className="space-y-1 ml-2">
                        {Array.from({ length: 4 }).map((_, itemIndex) => (
                            <Skeleton key={itemIndex} className="h-8 w-full" />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export function WidgetPreviewSkeleton() {
    return (
        <div className="space-y-4">
            <div className="rounded-x40 border border-stroke-x30 p-4">
                <Skeleton className="h-5 w-16 mb-3" />
                <div className="space-y-3">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-3/4" />
                    <Skeleton className="h-32 w-full" />
                    <div className="flex space-x-2">
                        <Skeleton className="h-8 w-20" />
                        <Skeleton className="h-8 w-16" />
                    </div>
                </div>
            </div>
        </div>
    );
}
